module.exports = __webpack_public_path__ + "img/orders_outline.a19e7d8d.svg";